<app-loader [hidden]="loadingCounter === 0"></app-loader>

<div class="flex flex-center flex-between">
  <app-page-title></app-page-title>
  <div class="flex flex-center flex-between" style="margin-top: 16px">
    <med-tab-group
      [options]="optionsTabGroup"
      [(value)]="optionsModel"
      (valueChange)="tabGroupChanged()">
      <ng-template medTemplate="tab" let-option>
        {{option.label}}
      </ng-template>
    </med-tab-group>
  </div>
</div>

<div class="table-wrapper" [hidden]="loadingCounter > 0">
  <p-table

    #dt2
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="flex"
    [value]="tableBodySpecifications"
    [customSort]="true"
    [lazy]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    (onLazyLoad)="loadData()">
    <ng-template pTemplate="header">
      <tr>
        <th><!-- checkbox row--></th>
        <th class="table-header-text" [pSortableColumn]="column.key" *ngFor="let column of filterHeader(tabHeaderSpecifications)" style="background-color: rgb(249, 249, 249)!important; min-width: 10em" pResizableColumn>
          <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'max-width': ['3', '10', '14', '15', '17', '19', '20', '21'].includes(column.key) ? '15em': 'initial'}" [ngClass]="{'no-wrap': ['3', '10', '14', '15', '17', '19', '20', '21'].includes(column.key)}">
            {{ column.label }}&nbsp;
            <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
            <med-icon-chevron-right [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'2' === column.key && column.showChevron && !hideGroup1" (click)="showHidedColumns($event, column.key, true)"></med-icon-chevron-right>
            <med-icon-chevron-left [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'2' === column.key && column.showChevron && hideGroup1" (click)="showHidedColumns($event, column.key, false)"></med-icon-chevron-left>
            <med-icon-chevron-right [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'17' === column.key && column.showChevron && !hideGroup2" (click)="showHidedColumns($event, column.key, true)"></med-icon-chevron-right>
            <med-icon-chevron-left [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'17' === column.key && column.showChevron && hideGroup2" (click)="showHidedColumns($event, column.key, false)"></med-icon-chevron-left>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr class="table-content-text" (dblclick)="goToDetails('10')">
        <td>
          <med-checkbox size="small"  *ngIf="'MZU' === dataService.userRoleValue.getValue()"
                        (change)="onChangeHandlerSpecification(row)"
                        [value]="basketService.containsAlreadySpecification(row.specificationId)"></med-checkbox>
        </td>
        <td class="h10-text black-80">
          <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.mnnName}}
                        </span>
          </div>
        </td>
        <td class="h10-text black-60">
          {{row.dosage}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          {{row.quantity}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          {{row.mnnId}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          {{row.lovId}}
        </td>
        <td class="h10-text black-60 grey-20-background" *ngIf="!hideGroup1">
          <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipDirectionSpec">
                          {{row.directionDto.shortName}}
                        </span>
          </div>
          <ng-template #tooltipDirectionSpec >
            <div class="flex items-center h10-text">
              {{row.directionDto.name}}
            </div>
          </ng-template>

        </td>
        <td class="h10-text black-60 grey-20-background" *ngIf="!hideGroup1">
          {{row.unit}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          "< no documents >"
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          {{row.subDirection}}
        </td>
        <td>
          <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.seriesCatalogue}}
                        </span>
          </div>
        </td>
        <td class="h10-text black-80">
          <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.tradeName}}
                        </span>
          </div>
        </td>
        <td class="h10-text black-80">
          {{row.multiplicity}}
        </td>
        <td class="h10-text black-80">
          {{row.quantity}}

        </td>
        <td class="h10-text black-80">
          {{row.adjUnitPrice}}
        </td>
        <td class="h10-text black-80">
          {{getRowSum(row.availableForDistribution, row.adjUnitPrice)}}
        </td>
        <td class="h10-text black-80">
          Номер договору *
        </td>
        <td class="h10-text black-80">
          {{row.dueDate | date: 'dd.MM.yyyy'}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
          {{row.manufacturer}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
          {{row.manufacturerCountry}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
          {{row.originCountry}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
          {{row.manufactureDate | date: 'dd.MM.yyyy'}}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex flex-center flex-between">
        <med-pagination
          [total]="totalRowsSpecifications"
          [page]="selectedPageNumberSpecifications"
          [perPage]="pageSizeSpecifications"
          (pageChange)="pageChangeSpecifications($event)"
        ></med-pagination>

        <div class="small-text">
          Показано &nbsp;<strong>{{ getFirstShowedRowIndexSpecifications() }}</strong>-<strong>{{ getFirstShowedRowIndexSpecifications() + pageSizeSpecifications }}</strong> &nbsp;з {{ totalRowsSpecifications }}
        </div>

        <div>
          <span class="small-text">Кількість на сторінку</span>
          <med-radio-group
            mode="buttons"
            [value]="totalRowsSpecifications"
            [options]="paginationOptions"
            (onInput)="pageSizeChangedSpecifications($event)"
          ></med-radio-group>
        </div>
      </div>
    </ng-template>
  </p-table>
</div>
